const InventoryAudit = {
    barcodeSearch: () => 'inventory/audit/product',
    itemCondition: (id: string) => `inventory/audit/product/${id}/condition`,
}
export default InventoryAudit